import React, { useState } from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import Rate from "../../../components/Rate";
import IconDesc from "../my-course/IconDesc";
import { bookIcon, boxOIcon, checkCircleIcon } from "../../../constants/icons";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";

function CourseDetailsHeader({className}) {
  const [rating, setRating] = useState(3.5);

  const round = (args) => {
    return Math.round(args)
  }
  
  return (
    <div className={`${className || ""} course-inner-header`} >
      <Container>
        <Row className="align-items-center">
          <Col lg={8}>
            <div className="course-description">
              <h1>The Complete Python Masterclass : Become a Python Engineer</h1>
              <p className="mb-1">Learn A-Z everything about Python, from the basics, to advanced topics like Python GUI, Python Data Analysis, and more!</p>
              <div className="rating-wrapper d-flex align-items-center gap-1 my-3">
                <div className="start-wrap">
                  <p className="mb-0">{round(rating)}</p>
                  <Rate
                    rating={rating}
                    count={5}
                    onRating={(rate) => setRating(rate)}
                  />
                </div>
              </div>
              <div className="rating-wrapper d-block d-md-flex align-items-center gap-3 mb-3 mt-1">
                <IconDesc
                  icon={bookIcon}
                  paraDesc="Instructed by"
                  linkDesc="Gokul"
                  link="#"
                  className="mb-1 mb-md-0"
                />
                <IconDesc
                  icon={checkCircleIcon}
                  paraDesc="Expiring on 29/07/2023"
                  className="mb-1 mb-md-0"
                />
                <IconDesc
                  icon={boxOIcon}
                  paraDesc="3 Courses"
                  className="mb-1 mb-md-0"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CourseDetailsHeader;
